<script lang="ts" setup>
import { useSiteStore } from '~/stores/site.store';
import { QuestionFilledIcon } from '~/components/design-system/icons/index';
const site = useSiteStore();
const theme = useColorMode();
</script>
<template>
  <div
    :class="[
      'w-[58px] md:w-max min-h-10',
      'dark:bg-dark-700 dark:border-gold-500',
      'border-[2px]  bg-gold-500 border-dark-700',
      'font-bold dark:text-gold-500 text-dark-700',
      'text-xs  mx-auto text-center leading-[12px]',
      'p-1.5 rounded-lg',
      'flex-center cursor-pointer',
    ]"
    @click="site.activateModal('accountRestricted')"
  >
    {{ $t('limited-access') }}
  </div>
  <QuestionFilledIcon class="cursor-pointer hidden md:block" />
</template>
